import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VBtn,{staticClass:"ml-4",attrs:{"color":"primary","small":""},on:{"click":_setup.enviarEmails}},[_c(VIcon,{staticClass:"mr-1",attrs:{"size":18}},[_vm._v("mdi-email")]),_vm._v("\n  Enviar e-mails\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }